// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"wn_a bhu_b bhu_ux"};